module.exports = __webpack_public_path__ + "img/cirugiadeparpados.02c81628.svg";